import { Navigate, Route, Routes } from "react-router-dom"

import { DashboardPage, GroupsPage, StudentsPage, CoursesPage, SchoolsPage, SedeCorreosCR, StudentsByGroupOrCurso } from "../../pages/admin"
import { LoadingScreen } from "../../ui/components/LoadingScreen";
import { useCheckIsAdmin } from "../../hooks";

export const AdminRoutes = () => {


    const { isAdmin, isCheckingRole, error } = useCheckIsAdmin();

    if (isCheckingRole) {
        return <LoadingScreen />; // O muestra algún spinner o componente de carga
    }

    if (!isAdmin) {
        return <Navigate to="/" />;
    }

    return (
        <Routes>

            <Route path="/" element={<DashboardPage />} />
            <Route path="/cursos" element={<CoursesPage />} />
            <Route path="/grupos" element={<GroupsPage />} />
            <Route path="/grupos/:id/estudiantes" element={<StudentsByGroupOrCurso />} />
            <Route path="/estudiantes-curso-grupo" element={<StudentsByGroupOrCurso />} />
            {/*  <Route path="/event/:id" element={<EventDetailsPage />} /> */}
            <Route path="/estudiantes" element={<StudentsPage />} />
            <Route path="/colegios" element={<SchoolsPage />} />
            <Route path="/sedecorreoscr" element={<SedeCorreosCR />} />


            <Route path="*" element={<Navigate to='/admin' />} />

        </Routes>
    )
}
